(() => {
  if (window.STDCategoryRails) {
    window.STDCategoryRails.refresh(document);
    return;
  }
  const rails = new WeakMap();
  const refresh = (root = document) => {
    root.querySelectorAll('.std-category-tiles > ul').forEach(rail => {
      if (rails.has(rail)) return;
      let drag = null;
      let suppressClick = false;
      const measure = () => {
        const overflow = rail.scrollWidth > rail.clientWidth + 2;
        rail.classList.toggle('has-overflow', overflow);
        rail.tabIndex = overflow ? 0 : -1;
      };
      const observer = new ResizeObserver(measure);
      observer.observe(rail);
      const finish = event => {
        if (!drag || event.pointerId !== drag.id) return;
        if (drag.moved) suppressClick = true;
        if (rail.hasPointerCapture(event.pointerId)) rail.releasePointerCapture(event.pointerId);
        rail.classList.remove('is-dragging');
        drag = null;
      };
      rail.addEventListener('pointerdown', event => {
        suppressClick = false;
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || !matchMedia('(min-width:768px)').matches || rail.scrollWidth <= rail.clientWidth + 2) return;
        drag = { id: event.pointerId, x: event.clientX, scroll: rail.scrollLeft, moved: false };
      });
      rail.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        const distance = event.clientX - drag.x;
        if (!drag.moved && Math.abs(distance) < 6) return;
        if (!drag.moved) {
          drag.moved = true;
          rail.setPointerCapture(event.pointerId);
          rail.classList.add('is-dragging');
        }
        event.preventDefault();
        rail.scrollLeft = drag.scroll - distance;
      });
      rail.addEventListener('pointerup', finish);
      rail.addEventListener('pointercancel', finish);
      rail.addEventListener('lostpointercapture', event => {
        if (drag && event.pointerId === drag.id) {
          if (drag.moved) suppressClick = true;
          rail.classList.remove('is-dragging');
          drag = null;
        }
      });
      rail.addEventListener('click', event => {
        if (!suppressClick) return;
        suppressClick = false;
        event.preventDefault();
        event.stopPropagation();
      }, true);
      rail.addEventListener('dragstart', event => event.preventDefault());
      rail.querySelectorAll('img').forEach(image => image.addEventListener('load', measure, { once: true }));
      rails.set(rail, observer);
      measure();
    });
  };
  window.STDCategoryRails = { refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => refresh());
  else refresh();
  document.addEventListener('shopify:section:load', event => refresh(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.std-category-tiles > ul').forEach(rail => {
      rails.get(rail)?.disconnect();
      rails.delete(rail);
    });
  });
})();
